module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/vux-server-render-support-49.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/faq/vux-server-render-support.md
// module id = 750
// module chunks = 192